<template>
  <div
    class="fit-dialog"
    :class="[
      { 'fit-dialog-vertical': isValignBtn, 'fit-dialog-weui': data.weui, 'show-dlg': !data.hidden },
      data.theme,
    ]"
    v-on:click="onLayerClick"
    v-on:touchmove.prevent
  >
    <div class="flex-center">
      <div class="dlg-main" v-on:click.stop>
        <div class="dlg-bar" v-if="data.closeBtn">
          <i v-on:click="onClose" class="dlg-icon-close"></i>
        </div>
        <div class="dlg-content flex-v flex-center" :class="{ noBorder: data.btns.length <= 0 }">
          <div class="dlg-title" v-if="data.title">{{ data.title }}</div>
          <div class="dlg-text">
            <div v-if="this.$slots.default">
              <slot></slot>
            </div>
            <div v-else-if="data.htmlContent" v-html="data.htmlContent"></div>
            <div class="plain-text" v-else>{{ data.content }}</div>
          </div>
        </div>
        <div v-if="data.btns.length > 0" class="dlg-btns flex" :class="{ onlyBtn: data.btns.length == 1 }">
          <button v-for="(btn, index) in data.btns" v-on:click="bindTap(btn)" :key="'btn' + index" class="flex-1">
            {{ btn.text }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import base from '../../mixins/base.js';
export default {
  name: 'fit-dialog',
  mixins: [base],
  props: {
    title: {
      type: String,
      default: '',
    },
    htmlContent: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: '',
    },
    btns: {
      type: Array,
      default() {
        return [];
      },
    },
    weui: {
      type: Boolean,
      default: false,
    },
    valignBtn: {
      type: Boolean,
      default: false,
    },
    closeBtn: {
      type: Boolean,
      default: false,
    },
    autoClose: {
      type: Boolean,
      default: false,
    },
    hidden: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      data: {
        title: this.title,
        htmlContent: this.htmlContent,
        content: this.content,
        theme: this.theme,
        btns: this.btns || [],
        weui: this.weui,
        valignBtn: this.valignBtn,
        closeBtn: this.closeBtn,
        autoClose: this.autoClose,
        hidden: this.hidden,
      },
    };
  },
  computed: {
    isValignBtn() {
      let btn = null;
      if (this.data.valignBtn) {
        return this.data.valignBtn;
      }
      if (this.data.btns && this.data.btns.length > 2) {
        return true;
      }
      if (this.data.btns && this.data.btns.length === 2) {
        for (let i = this.data.btns.length - 1; i >= 0; i--) {
          btn = this.data.btns[i];
          if (btn && btn.text && btn.text.length > 14) {
            return true;
          }
        }
      }
      return false;
    },
    isHidden: {
      get() {
        return this.data.hidden;
      },
      set(value) {
        this.data.hidden = value;
        this.$emit('input', value);
      },
    },
  },
  watch: {
    title() {
      this.data.title = this.title;
    },
    htmlContent() {
      this.data.htmlContent = this.htmlContent;
    },
    content() {
      this.data.content = this.content;
    },
    theme() {
      this.data.theme = this.theme;
    },
    btns() {
      this.data.btns = this.btns || [];
    },
    weui() {
      this.data.weui = this.weui;
    },
    valignBtn() {
      this.data.valignBtn = this.valignBtn;
    },
    closeBtn() {
      this.data.closeBtn = this.closeBtn;
    },
    autoClose() {
      this.data.autoClose = this.autoClose;
    },
    hidden() {
      this.data.hidden = this.hidden;
    },
  },
  methods: {
    bindTap(btn) {
      if (btn && typeof btn.click === 'function') {
        btn.click();
      } else {
        this.hide();
      }
    },
    show(args) {
      if (sessionStorage.getItem('loggingIn') === '1') {
        return;
      }
      const self = this;
      if (args) {
        Object.keys(this.data).forEach((key) => {
          if (args.hasOwnProperty(key) && typeof this.data[key] === typeof args[key]) {
            this.data[key] = args[key];
          } else {
            const prop = this.$options.props[key];
            if (prop) {
              let defValue = prop.default;
              if ((prop.type === Object || prop.type === Array) && typeof defValue === 'function') {
                defValue = defValue.call(self);
              }
              this.data[key] = defValue;
            }
          }
        });
      }
      this.isHidden = false;
    },
    hide() {
      this.isHidden = true;
    },
    onClose() {
      this.hide();
    },
    onLayerClick(e) {
      if (this.data.autoClose) {
        this.hide();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.fit-dialog {
  position: fixed;
  display: none;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  font-size: 16px;
  line-height: 1;
  z-index: 999;
}
.fit-dialog.show-dlg {
  display: block;
}
.fit-dialog .dlg-main {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 270px;
  background-color: #e7e7e7;
  border-radius: 12px;
  overflow: hidden;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.fit-dialog .dlg-title {
  padding-bottom: 9px;
  font-weight: bold;
}
.fit-dialog .dlg-content {
  position: relative;
  text-align: center;
  padding: 15px 20px;
  line-height: 23px;
  min-height: 20px;
  color: #000;
}
.fit-dialog .dlg-text {
  text-align: center;
}
.fit-dialog .dlg-text .plain-text {
  display: inline-block;
  text-align: left;
}
.fit-dialog .dlg-content img {
  max-width: 244px;
}
.fit-dialog .dlg-content:after {
  position: absolute;
  content: '';
  bottom: 0;
  left: 0;
  right: 0;
  height: 0;
  color: #bababa;
  border-top: 1px solid #bababa;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.fit-dialog .dlg-content.noBorder:after {
  border-top: none;
}
.fit-dialog .dlg-btns button {
  position: relative;
  height: 44px;
  color: #0076ff;
  font-size: 17px;
  background: #e7e7e7;
}
.fit-dialog .dlg-btns button:active {
  background: rgba(0, 0, 0, 0.1);
}
.fit-dialog .dlg-btns button:nth-child(2):before {
  position: absolute;
  content: '';
  top: 0;
  bottom: 0;
  left: 0;
  width: 0px;
  color: #bababa;
  border-left: 1px solid #bababa;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleX(0.5);
  transform: scaleX(0.5);
}
.fit-dialog button {
  cursor: pointer;
  border: none;
}
.fit-dialog .dlg-bar {
  position: absolute;
  right: 0px;
  top: 2px;
  z-index: 1;
  font-size: 20px;
  width: 40px;
  text-align: center;
}

.fit-dialog .dlg-icon-close:before,
.dlg-icon-close:after {
  content: '';
  position: absolute;
  width: 40%;
  height: 1px;
  background-color: #333;
  top: 50%;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.fit-dialog .dlg-icon-close:before {
  -webkit-transform: rotateZ(45deg);
  transform: rotateZ(45deg);
}
.fit-dialog .dlg-icon-close {
  position: relative;
  width: 30px;
  height: 30px;
  display: inline-block;
}
.fit-dialog .dlg-icon-close:after {
  -webkit-transform: rotateZ(-45deg);
  transform: rotateZ(-45deg);
}

.fit-dialog-vertical .dlg-btns {
  -webkit-box-orient: vertical;
  -webkit-flex-direction: column;
  flex-direction: column;
}
.fit-dialog-vertical .dlg-btns button:after {
  position: absolute;
  content: '';
  bottom: 0;
  left: 0;
  right: 0;
  height: 0;
  color: #bababa;
  border-top: 1px solid #bababa;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.fit-dialog-vertical .dlg-btns button:last-child:after {
  content: none;
}

.fit-dialog-weui .dlg-main {
  width: 280px;
  background-color: #fefefe;
  border-radius: 4px;
}
.fit-dialog-weui .dlg-title {
  padding-bottom: 9px;
}
.fit-dialog-weui .dlg-content {
  color: #353535;
  padding: 24px 20px 15px 20px;
  line-height: 22px;
}
.fit-dialog-weui .dlg-title + .dlg-text {
  color: #888;
}
.fit-dialog-weui .dlg-content:after {
  border-color: #e4e4e4;
}
.fit-dialog-weui .dlg-btns button {
  height: 50px;
  line-height: 50px;
  color: #000000;
  background: #fefefe;
}
.fit-dialog-weui .dlg-btns button:last-child {
  color: #02bb00;
}
.fit-dialog-weui .dlg-btns button:nth-child(2):before {
  border-color: #e4e4e4;
}
.fit-dialog-weui button {
  cursor: pointer;
  border: none;
}

.fit-dialog-weui.dlg-non-user .dlg-main {
  width: 320px;
  background-color: #fefefe;
  border-radius: 4px;
}
.fit-dialog-weui.dlg-non-user .dlg-content {
  padding: 34px 20px 25px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fit-dialog-weui .dlg-bar {
  position: absolute;
  right: 0px;
  top: 2px;
  z-index: 1;
  font-size: 20px;
  width: 40px;
  text-align: center;
}
.fit-dialog-weui .dlg-icon-close:before,
.dlg-icon-close:after {
  content: '';
  position: absolute;
  width: 40%;
  height: 1px;
  background-color: #333;
  top: 50%;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.fit-dialog-weui .dlg-icon-close:before {
  -webkit-transform: rotateZ(45deg);
  transform: rotateZ(45deg);
}
.fit-dialog-weui .dlg-icon-close {
  position: relative;
  width: 30px;
  height: 30px;
  display: inline-block;
}
.fit-dialog-weui .dlg-icon-close:after {
  -webkit-transform: rotateZ(-45deg);
  transform: rotateZ(-45deg);
}

.fit-dialog-green .dlg-main {
  width: auto;
  min-width: 320px;
  background-color: #fefefe;
  border-radius: 12px;
  margin-top: -30px;
  overflow: initial;
}
.fit-dialog-green .dlg-title {
  padding-bottom: 15px;
}
.fit-dialog-green .dlg-content {
  color: #353535;
  padding: 23.5px 18px 17.5px;
  line-height: 22px;
}
.fit-dialog-green .dlg-title + .dlg-text {
  width: 100%;
  color: #888;
}
.fit-dialog-green .dlg-content:after {
  border: none;
}
.fit-dialog-green .dlg-btns {
  justify-content: center;
}
.fit-dialog-green .dlg-btns button {
  color: #23b75e;
  font-size: 17px;
  text-align: center;
  line-height: 40px;
  width: 100px;
  height: 40px;
  border-radius: 4px;
  background-color: #f2f2f2;
  margin: 0 15.5px 17.5px 0;
}
.fit-dialog-green .dlg-btns button:last-child {
  background-color: #23b75e;
  color: #fff;
  margin-right: 0;
}
.fit-dialog-green .dlg-btns button:before {
  border: none;
}
.fit-dialog-green .dlg-btns button:after {
  border: none;
}
.fit-dialog-green .dlg-btns button:nth-child(2):before {
  border: none;
}
.fit-dialog-green .dlg-btns.onlyBtn button {
  width: 195px;
}
.fit-dialog-green button {
  cursor: pointer;
  border: none;
}
.fit-dialog-green .dlg-btns button.flex-1 {
  flex: none;
}

.fit-dialog-green .dlg-bar {
  position: absolute;
  right: 50%;
  top: 100%;
  margin-top: 30px;
  margin-right: -20px;
  z-index: 1;
  font-size: 20px;
  width: 40px;
  text-align: center;
  align-items: center;
}
.fit-dialog-green .dlg-icon-close:before,
.dlg-icon-close:after {
  content: '';
  position: absolute;
  width: 40%;
  height: 1px;
  background-color: #fff;
  top: 50%;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.fit-dialog-green .dlg-icon-close:before {
  -webkit-transform: rotateZ(45deg);
  transform: rotateZ(45deg);
}
.fit-dialog-green .dlg-icon-close {
  position: relative;
  width: 30px;
  height: 30px;
  display: inline-block;
  border: 1px solid #fff;
  border-radius: 30px;
}
.fit-dialog-green .dlg-icon-close:after {
  -webkit-transform: rotateZ(-45deg);
  transform: rotateZ(-45deg);
}

.fit-dialog-img .dlg-main {
  width: auto;
  background-color: transparent;
  overflow: initial;
}

@media (width: 320px) {
  .fit-dialog-green .dlg-main {
    min-width: 272px;
  }
}
.flex {
  display: flex;
  justify-content: center;
}
</style>
